import * as React from 'react';

function SvgErrorFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 26C9.149 26 4 20.851 4 14.5S9.149 3 15.5 3 27 8.149 27 14.5 21.851 26 15.5 26z"
        fill="#414B56"
      />
      <path
        d="M14.589 14.5L10.06 9.862a.574.574 0 010-.797.54.54 0 01.777 0l4.624 4.736a.552.552 0 01.075 0l4.625-4.736a.54.54 0 01.777 0 .574.574 0 010 .797L16.41 14.5l4.528 4.638a.574.574 0 010 .797.54.54 0 01-.777 0L15.537 15.2a.552.552 0 01-.075 0l-4.624 4.736a.54.54 0 01-.777 0 .574.574 0 010-.797L14.59 14.5z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgErrorFilled;
